<template>
  <div class="index">
    <Seacher></Seacher>
    <div class="transactionsbox">
      <div class="transactionstit">Block Detail</div>
      <div class="transactionsc">
        <div class="tit">BK Hash :</div>
        <div class="conc concs">
          <div class="blockhash">{{ blockHash }}</div>
          <img
            src="../../assets/m/copy@2x.png"
            v-clipboard:copy="blockHash"
            v-clipboard:success="copyClicked"
            v-clipboard:error="onError"
          />
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Block Height :</div>
        <div
          class="conc"
          style="margin-top: 6px"
          @click="goDetail('height', height)"
        >
          <span>{{ height }}</span>
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Previous Block Hash :</div>
        <div class="conc conca" style="margin-top: 6px">
          <div @click="goDetail('blockHash', BlockHash)">{{ BlockHash }}</div>
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Packer :</div>
        <div
          class="conc"
          style="margin-top: 6px; display: flex"
          @click="goDetail('address', packer)"
        >
          <img :src="packerLogo" /><span
            style="margin-top: 4px; display: block"
          >
            {{ packerName }}</span
          >
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Time :</div>
        <div class="conc" style="margin-top: 6px">
          {{ time }} ({{ timeas }})
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Size :</div>
        <div class="conc" style="margin-top: 6px">
          {{ Number(Size).toLocaleString() }}bytes
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Tx Count :</div>
        <div class="conc">{{ tradeNums }} Txns</div>
      </div>
      <div class="transactionsc transactionscd">
        <div class="tit" style="margin-bottom: 6px">Block signer :</div>

        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            :title="signList.length + ' signers (See all)'"
            name="1"
          >
            <div class="block_boxlist">
              <div
                class="block_li"
                v-for="(item, index) in signList"
                :key="index"
              >
                <span @click="goDetail('address', item)"> {{ item }}</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate"
          >Transactions <b class="notranslate">({{ total }})</b></span
        >
      </div>
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Txn Hash</li>
                  <li>Type</li>
                  <li class="xila">Age</li>
                  <li>From</li>
                  <li>To</li>
                  <li>Amout</li>
                  <!-- <li>Amount</li> -->
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li v-for="(transfer, index) in transferList" :key="index">
                    <p @click.prevent="goDetail('txnhash', transfer)">
                      {{ transfer.txHash1 }}
                    </p>
                    <p v-if="transfer.type == 8">{{ transfer.contractName }}</p>
                    <p v-else>{{ transfer.type }}</p>
                    <p>{{ transfer.tradeTime }}</p>
                    <p
                      v-if="
                        transfer.type != 'Unstake' &&
                        transfer.fromAddress != 'Unpledge' &&
                        transfer.type != 'Bonus'
                      "
                      @click="goDetail('address', transfer.fromAddress)"
                    >
                      {{ transfer.fromAddress1 }}
                    </p>
                    <p
                      v-if="
                        transfer.type == 'Unstake' ||
                        transfer.fromAddress == 'Unpledge'
                      "
                    >
                      {{
                        transfer.fromAddress == "Unpledge"
                          ? "Unstake"
                          : transfer.fromAddress1
                      }}
                    </p>
                    <p v-if="transfer.type == 'Bonus'">Bonus</p>
                    <p
                      v-if="
                        transfer.type == 'Transfer' ||
                        transfer.type == 'Delegate' ||
                        transfer.type == 'Withdraw' ||
                        transfer.type == 'Unstake' ||
                        transfer.type == 'Bonus' ||
                        transfer.type1 == 8 ||
                        transfer.type1 == 7
                      "
                    >
                      <span
                        v-if="transfer.toAddress !== ''"
                        @click.prevent="goDetail('address', transfer.toAddress)"
                        >{{ transfer.toAddress1 }}</span
                      >
                      <span style="color: #8d8d8d; display: block" v-else
                        >...</span
                      >
                    </p>
                    <p style="color: #8d8d8d" v-if="transfer.type == 'Genesis'">
                      ...
                    </p>
                    <p v-if="transfer.type == 'Signature Rewards'">
                      Signature Rewards
                    </p>
                    <p v-if="transfer.type == 'Stake'">Stake</p>
                    <!-- <p>
                      0.00090916 <img src="../../assets/m/home/hot.png" /> LKMEX
                    </p> -->
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' && transfer.type1 == 7
                      "
                      style="color: #8d8d8d"
                    >
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          margin-top: 10px;
                          margin-right: 4px;
                        "
                      />{{ transfer.contractName }}
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 7
                      "
                      style="color: #fff; cursor: pointer"
                      @click="cHash1(index)"
                    >
                      {{ transfer.tokenAmount }}
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          margin-top: 10px;
                          margin-right: 4px;
                        "
                      />
                      <span v-if="transfer.symbol.length > 10"
                        >{{ transfer.symbol.slice(0, 8) }}...</span
                      >
                      <span v-else> {{ transfer.symbol }}</span>
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 8
                      "
                      style="color: #fff; cursor: pointer"
                      @click="cHash1(index)"
                    >
                      <!-- {{ transfer.tokenAmount }} -->
                      <span
                        v-if="
                          transfer.tokenAmount.length > 8 &&
                          transfer.tokenAmount > 999
                        "
                      >
                        {{
                         
                            transfer.tokenAmount.slice(0, 8)
                          
                        }}...</span
                      >
                      <span v-else>
                        <!-- {{ Number(transfer.tokenAmount).toLocaleString() }} -->
                        {{
                         transfer.tokenAmount
                        }}
                      </span>
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          margin-top: 10px;
                          margin-right: 4px;
                        "
                      />{{ transfer.symbol }}
                    </p>
                    <!-- 合约执行 -->
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' &&
                        transfer.type1 == 8 &&
                        transfer.tokenAmount == ''
                      "
                      style="color: #8d8d8d"
                    >
                      <!-- //   item.logo -->
                      <img
                        v-if="transfer.functions == 'Contract Execute'"
                        :src="imgurl"
                        style="
                          width: 28px;
                          height: 28px;

                          margin-right: 10px;
                          margin-top: 4px;
                          border-radius: 50%;
                        "
                      />
                      <img
                        v-if="transfer.functions !== 'Contract Execute'"
                        :src="transfer.logo"
                        style="
                          width: 28px;
                          height: 28px;
                          border-radius: 4px;
                          margin-right: 10px;
                          margin-top: 4px;
                        "
                      />
                      <span>{{ transfer.contractName }}</span>
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' &&
                        transfer.type1 == 8 &&
                        transfer.tokenAmount !== ''
                      "
                      style="color: #fff; cursor: pointer"
                    >
                      <!-- //   item.logo -->
                      <img
                        :src="transfer.logo"
                        @click="cHash(index)"
                        style="
                          height: 28px;
                          border-radius: 4px;
                          margin-right: 10px;
                          margin-top: 4px;
                        "
                      />
                      <span @click="cHash(index)">{{
                        transfer.contractName
                      }}</span>
                      <span @click="cHash(index)">{{
                        transfer.tokenAmount.split(",")[0]
                      }}</span>
                    </p>
                    <p
                      style="color: #8d8d8d"
                      v-if="
                        (transfer.type1 !== 8 ||
                          transfer.type1 !== 7 ||
                          transfer.type == 'Genesis') &&
                        transfer.standard == ''
                      "
                    >
                      <!-- {{ transfer.amount }} -->
                      <!-- {{ Number(transfer.amount).toLocaleString() }} -->
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(transfer.amount)
                      }}
                      TTOS
                    </p>
                    <!-- <p style="color: #8d8d8d;"
                      v-if="transfer.type1==-1
                     
                      "
                    >
                      0
                      TTOS
                    </p> -->

                    <!-- <p
                      v-if="
                        transfer.standard == 'ERC-721' && transfer.type1 == 7
                      "
                      style="color: #898b8d !important"
                    >
                      
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          margin-top: 10px;
                          border-radius: 50%;
                        "
                      />0
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 7
                      "
                    >
                     
                      {{ transfer.tokenAmount }}
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          margin-top: 10px;
                          border-radius: 50%;
                        "
                      />{{ transfer.symbol }}
                    </p>
                    <p
                      v-if="
                        transfer.standard == 'ERC-20' && transfer.type1 == 8
                      "
                    >
                      {{ transfer.tokenAmount }}
                      <img
                        :src="transfer.logo"
                        style="
                          width: 24px;
                          height: 24px;
                          margin-top: 10px;
                          border-radius: 50%;
                        "
                      />{{ transfer.symbol }}
                    </p>
                  
                    <p
                      v-if="
                        transfer.standard == 'ERC-721' && transfer.type1 == 8
                      "
                      style="color: #fff; cursor: pointer"
                      @click="cHash(index)"
                    >
                      <img
                        :src="transfer.logo"
                        style="width: 24px; height: 24px; margin-top: 10px"
                      />{{ transfer.contractName }} {{ transfer.tokenAmount }}
                    </p>
                    <p
                      v-if="
                        (transfer.type1 !== 8 || transfer.type1 !== 7) &&
                        transfer.standard == ''
                      "
                    >
                      {{ transfer.amount }}
                      TTOS
                    </p> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
import { BlockDetail, GetblockDetail } from "../../assets/server/api.js";
import {
  timestampConvertTime,
  formatSeconds,
  listType,
  getSubStr,
  formattedNumber
  
} from "../../utils/utils.js";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: null,
      total: null,
      pageNum: 1,
      pagerCount: 0,
      Hash: "0x0f4248977e24...",
      blockHash: "",
      time: "",
      timeas: "",
      tradeNums: 0,
      height: 0,
      transferList: [],
      //开始
      //  blockHash:"",
      activeNames: ["0"],
      height: "",
      prevHash: "",
      BlockHash: "",
      packerLogo: "",
      packerName: "",
      packer: "",
      tradeNums: "",
      blockTime: "",
      Size: "",
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurl1: require("@/assets/pc/Index/vers.png"),
      imgurlnft: require("@/assets/pc/Index/nft.png"),
      signList: [],
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {},
  mounted() {
    this.getBlockDetail();
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    goBack() {
      history.go(-1);
      // this.$router.replace({ path: "/m/BlockList" });
    },
    Overview(index) {
      this.$router.push({
        path: "/m/NftOveraddress",
        query: { contractAddress: index },
      });
    },
    cHash1(Index) {
      //   console.log(Index);
      let params = {
        contractAddress: this.transferList[Index].contractAddress,
      };
      //    console.log(params);
      this.$router.push({ path: "/m/Overaddress", query: params });
    },
    cHash(Index) {
      //    console.log(Index);
      let params = {
        contractAddress: this.transferList[Index].contractAddress,
        tokenId: this.transferList[Index].tokenAmount.split(",")[0],
      };
      //    console.log(params);
      this.$router.push({ path: "/m/NFTslistdetail", query: params });
    },
    handleChange(val) {
      //   console.log(val);
    },
    async getBlockDetail() {
      let formData = new FormData();
      let params = {
        blockHash: this.$route.query.blockHash,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetblockDetail(formData);
      //      console.log(res);
      this.blockHash = res.result.blockInfo.blockHash;
      //     console.log(this.blockHash);
      this.height = res.result.blockInfo.height;
      // this.prevHash = res.result.blockInfo.prevHash;
      this.BlockHash = res.result.blockInfo.prevHash;
      this.packerName = res.result.blockInfo.packerName;
      this.packerLogo = res.result.blockInfo.packerLogo;
      this.tradeNums = res.result.blockInfo.tradeNums;
      this.signList = res.result.blockInfo.signStr.split(",");
      this.packer = res.result.blockInfo.packer;
      this.Size = res.result.blockInfo.bytes;
      // this.blockTime=res.result.blockInfo.blockTime;
      var calctimea = new Date();
      let strdate = Math.floor(calctimea.getTime() / 1000);
      this.time = res.result.blockInfo.blockTime;
      var offset = this.getClientTimezone;
      var korean = 3600000 * offset;
      var ass = res.result.blockInfo.blockTime - korean;
      this.timeas = timestampConvertTime(ass);
      let timestamp = Math.floor(this.gltimea(this.time) / 1000);
      var ss = strdate - timestamp;
      this.time = formatSeconds(ss);
      if (this.packerLogo == "") {
        this.packerLogo = this.imgurl1;
      }
      if (this.packerName == "") {
        this.packerName = getSubStr(res.result.blockInfo.packer, 0, 6);
      }

      // blockHash:"",
      // height:"",
      // prevHash:"",
      // packerLogo:"",
      // packerName:"",
      // tradeNums:""
      this.total = res.result.blockInfo.tradeNums;
      // var calctimea = new Date();
      // let strdatea = Math.floor(calctimea.getTime() / 1000);
      this.transferList = res.result.tradeList;
      //      console.log(this.transferList);
      for (let i = 0; i < this.transferList.length; i++) {
        this.transferList[i].tokenAmount=formattedNumber(this.transferList[i].tokenAmount);
        if (this.transferList[i].amount == "") {
          this.transferList[i].amount == "...";
        }
        //  console.log( _this.list2.toAddress);
        this.transferList[i].txHash1 = getSubStr(
          this.transferList[i].txHash,
          0,
          3
        );
        this.transferList[i].toAddress1 = getSubStr(
          this.transferList[i].toAddress,
          0,
          3
        );
        this.transferList[i].fromAddress1 = getSubStr(
          this.transferList[i].fromAddress,
          0,
          3
        );
        this.transferList[i].fromEvmAddress1 = getSubStr(
          this.transferList[i].fromEvmAddress,
          0,
          3
        );
        this.transferList[i].toEvmAddress1 = getSubStr(
          this.transferList[i].toEvmAddress,
          0,
          3
        );
        //       console.log(this.transferList);
        this.transferList[i].type1 = this.transferList[i].type;
        this.transferList[i].type = listType(this.transferList[i].type);
        if (
          this.transferList[i].standard !== "ERC-20" &&
          (this.transferList[i].logo == "" ||
            this.check_is_img(this.transferList[i].logo) == false)
        ) {
          // this.transferList[i].logo = this.imgurlnft;
          if (this.transferList[i].type1 == "7") {
            this.transferList[i].logo = this.imgurl;
          } else {
            this.transferList[i].logo = this.imgurlnft;
          }
        }
        if (
          this.transferList[i].standard == "ERC-20" &&
          (this.transferList[i].logo == "" ||
            this.check_is_img(this.transferList[i].logo) == false)
        ) {
          // this.transferList[i].logo = this.imgurl;
          if (this.transferList[i].logo !== "") {
            this.transferList[i].logo = this.transferList[i].logo;
          } else {
            this.transferList[i].logo = this.imgurl;
          }
        }
        if (
          this.transferList[i].type1 == "8" &&
          this.transferList[i].standard == "ERC-721" &&
          this.transferList[i].nftImageList !== ""
        ) {
          var images = JSON.parse(this.transferList[i].nftImageList);
          //         console.log(images);
          this.transferList[i].logo = images[0];
        } else {
          if (this.transferList[i].standard == "ERC-721") {
            this.transferList[i].logo = this.imgurlnft;
          }
          // if (this.transferList[i].standard == "ERC-721") {
          //   if(this.transferList[i].logo ==' '){
          //   this.transferList[i].logo = this.imgurlnft;}else{
          //     this.transferList[i].logo =this.transferList[i].logo ;
          //   }
          // }
          // this.transferList[i].logo = this.imgurlnft;
        }
        if (
          this.transferList[i].standard == "ERC-721" &&
          this.transferList[i].type1 == "7"
        ) {
          if (this.transferList[i].logo == " ") {
            this.transferList[i].logo = this.imgurl;
          } else {
            this.transferList[i].logo = this.transferList[i].logo;
          }
        }
        if (this.transferList[i].type == 8) {
          this.transferList[i].type = this.transferList[i].functions;
          this.transferList[i].toAddress1 = this.transferList[i].toEvmAddress1;
          this.transferList[i].fromAddress1 =
            this.transferList[i].fromEvmAddress1;
          this.transferList[i].toAddress = this.transferList[i].toEvmAddress;
          this.transferList[i].fromAddress =
            this.transferList[i].fromEvmAddress;
        }
        if (this.transferList[i].type == 7) {
          this.transferList[i].type = "ContractCreation";
        }
        // let UTCTime1 =
        //   res.result.tradeList[i].tradeTime -
        //   this.getClientTimezone * 3600000;
        // this.TimeDate1[i] = timestampConvertTime(UTCTime1);
        let timestamp = Math.floor(this.transferList[i].tradeTime / 1000);

        var s = strdate - timestamp;
        if (s <= 0) {
          s = 1;
        }
        this.transferList[i].tradeTime = formatSeconds(s);
        if (this.transferList[i].nftNameList !== "") {
          this.transferList[i].contractName = JSON.parse(
            this.transferList[i].nftNameList
          )[0];
          //  console.log(this.transferList[i].contractName);
        }
        if (this.transferList[i].type == "Genesis") {
          this.transferList[i].amount = 0;
        }
        if (
          this.transferList[i].standard == "ERC-721" &&
          this.transferList[i].type1 == "7" &&
          this.transferList[i].contractName == ""
        ) {
          this.transferList[i].contractName = getSubStr(
            this.transferList[i].contractAddress,
            0,
            3
          );
        }
        if (
          this.transferList[i].standard == "ERC-20" &&
          this.transferList[i].type1 == "7"
        ) {
          if (
            this.transferList[i].symbol == "" ||
            this.transferList[i].symbol == null
          ) {
            this.transferList[i].symbol = this.transferList[i].contractName;
          }
        }

        // this.list2[i].toAddress = _this.list2[i].toAddress.split(",");
      }
      // for (var i = 0; i < this.transferList.length; i++) {
      //   this.transferList[i].type1 = this.transferList[i].type;
      //   this.transferList[i].txHash1 = getSubStr(
      //     this.transferList[i].txHash,
      //     0,
      //     5
      //   );

      //   this.transferList[i].type = listType(this.transferList[i].type);
      //   // if( this.transferList[i].type==8){
      //   //   this.transferList[i].type= this.transferList[i].contractName;
      //   // }
      //   if (
      //     this.transferList[i].type1 == "8" &&
      //     this.transferList[i].standard == "ERC-721" &&
      //     this.transferList[i].nftImageList !== ""
      //   ) {
      //     var images = JSON.parse(this.transferList[i].nftImageList);
      //     console.log(images);
      //     this.transferList[i].logo = images[0];
      //   }
      //   if (this.transferList[i].type == 8) {
      //     this.transferList[i].type = this.transferList[i].functions;
      //     this.transferList[i].toAddress1 = this.transferList[i].toEvmAddress1;
      //     this.transferList[i].fromAddress1 =
      //       this.transferList[i].fromEvmAddress1;
      //     this.transferList[i].toAddress = this.transferList[i].toEvmAddress;
      //     this.transferList[i].fromAddress =
      //       this.transferList[i].fromEvmAddress;
      //   }
      //   if (this.transferList[i].type == 7) {
      //     this.transferList[i].type = "ContractCreation";
      //   }
      //   this.transferList[i].fromAddress1 = getSubStr(
      //     this.transferList[i].fromAddress,
      //     0,
      //     3
      //   );
      //   this.transferList[i].toAddress1 = getSubStr(
      //     this.transferList[i].toAddress,
      //     0,
      //     3
      //   );
      //   let timestampa = Math.floor(
      //     this.gltimea(this.transferList[i].tradeTime) / 1000
      //   );
      //   var s = strdatea - timestampa;
      //   if (s <= 0) {
      //     s = 1;
      //   }
      //   this.transferList[i].tradeTime = formatSeconds(s);
      // }
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.getBlockDetail();
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    goDetail(name, query) {
      //   console.log(query);
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
        case "txnhash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: {
              txHash: query.txHash,
              type: query.type1,
              standard: query.standard,
            },
            // query: { txHash: query },
          });
          break;
        case "blockHash":
          this.$router.push({
            path: "/m/BlockDetails",
            query: { blockHash: query },
          });
          this.getBlockDetail();
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockHeight",
            query: { height: query },
          });
          break;
      }
    },
    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-collapse-item__wrap {
  background: #0b0c0f !important;
  border: none !important;
}
/deep/.el-collapse-item__header {
  background: #0b0c0f !important;
  border: none !important;
  color: #fff !important;
  line-height: 50px !important;
  height: 50px !important;
  border: 1px solid red;
  padding-bottom: 20px;
}
/deep/.el-collapse {
  border: none !important;
}
/deep/.el-collapse-item__arrow {
  display: none;
}
/deep/.el-dialog__title {
  margin-left: 80px;
  font-size: 14px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 500;
  color: #898b8d;
}
/deep/.el-message {
  margin-top: 170px !important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
/deep/.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

/deep/.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.el-pagination {
  padding-bottom: 40px !important;
}

.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .transactionsbox {
    width: 702px;
    margin: 0 auto;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin-top: 24px;
    .tangkuang {
      // border: 1px solid red;
      width: 410px;
      margin: 0 auto;
      .tangkuang_tit {
        display: flex;
        justify-content: space-between;
        height: 50px;
        div {
          height: 26px;
          font-size: 18px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          line-height: 26px;
        }
      }
      .tangkuang_con {
        height: 200px;
        .tangkuang_li {
          display: flex;
          height: 40px;
          img {
            width: 24px;
            height: 24px;
            margin-left: 42px;
            // margin-right: 12px;
          }
          span {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          span:nth-child(1) {
            width: 200px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          span:nth-child(3) {
            width: 200px;
            text-align: right;
          }
        }
      }
    }
    .transactionstit {
      text-align: left;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      margin-left: 24px;
      padding-top: 24px;
    }
    .transactionsc {
      text-align: left;
      margin-left: 24px;
      margin-top: 30px;
      border-bottom: 1px solid #22252e;
      padding-bottom: 10px;
      .tit {
        // height: 36px;
        font-size: 26px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        // line-height: 36px;
        // border: 1px solid red;
        margin-bottom: 6px;
      }
      .conca {
        display: flex;
        div {
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;

          // line-height: 36px;
          // margin-bottom: 26px;

          width: 75.3vw;

          font-size: 3.5vw;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #fff;

          word-wrap: break-word;
        }
        img {
          width: 46px;
          height: 46px;
          margin-left: 20px;
          margin-top: 10px;
        }
      }
      .concs {
        display: flex;
        .blockhash {
          width: 600px;
        }
        img {
          width: 60px;
          height: 60px;
        }
      }
      .conc {
        font-size: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;
        // line-height: 36px;
        margin-bottom: 26px;
        width: 75.3vw;

        font-size: 3.5vw;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;

        word-wrap: break-word;
        img {
          width: 50px;
          height: 50px;
          // border:1px solid red;
          border-radius: 50%;
        }
        span {
          color: #fff;
          margin-left: 6px;
        }
        .block_toli {
          display: flex;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding-top: 10px;

          span {
            width: 400px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          img {
            width: 26px;
            height: 26px;
            margin-left: 30px;
            margin-right: 30px;
          }
        }
        .btns {
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          margin-top: 10px;
        }
        .block_hash {
          margin-top: 14px;
          margin-left: 12px;
          color: #fff;
        }
        // span{
        //   width: 120px;
        // }
      }
      .block_boxlist {
        display: flex;
        flex-wrap: wrap;
        // margin-top: 30px;
        .block_li {
          width: 280px;
          // height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          margin-right: 30px;
          // line-height: 34px;
          // margin-bottom: 30px;
        }
      }
    }
    .transactionscd {
      border-bottom: none;
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1600px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              margin-left: 24px;
              width: 200px;
            }
            li:nth-child(2) {
              width: 300px;
            }
            li:nth-child(3) {
              width: 400px;
            }
            li:nth-child(4) {
              width: 200px;
              text-align: center;
            }
            li:nth-child(5) {
              width: 200px;
              text-align: center;
            }
            li:nth-child(6) {
              width: 300px;
            }
            // li:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
        .Block_List_center {
          width: 1600px;
          ul {
            //  height: 620px;
            width: 1600px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 200px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 300px;
              color: #8a8a8a;
              img {
                width: 30px;
                height: 30px;
                margin-top: 24px;
                margin-right: 10px;
              }
            }
            p:nth-child(3) {
              width: 400px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 200px;
              text-align: center;
            }
            p:nth-child(5) {
              width: 200px;
              text-align: center;
            }
            p:nth-child(6) {
              width: 300px;
              color: #8a8a8a;
            }
            // p:nth-child(6) {
            //   width: 400px;
            //   margin-right: 4px;
            //   img {
            //     width: 30px;
            //     height: 30px;
            //     margin-top: 24px;
            //     margin-right: 10px;
            //   }
            // }
            // p:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    background: #232a35;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    .block {
      margin-top: 51px;
      margin-bottom: 50px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 39px;
    }
  }

  .head {
    width: 690px;
    padding: 24px 12px;
    background: #0b0c0f;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 30px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .xian {
    border-bottom: none !important;
  }

  .title {
    width: 200px;
  }
}
</style>
